import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ResourceProvider } from "@/Common/Resources/StaticResources";
import { Button } from "@/DesignSystem";

import styles from "./RecoveryEmailPopups.module.scss";

interface IRecoveryEmailIsMandatoryPopupProps {
    stringProvider?: ResourceProvider;

    onBackButtonClick: () => void;
    onContinueWithoutEmail: () => void;
}

function RecoveryEmailIsMandatoryPopup(props: IRecoveryEmailIsMandatoryPopupProps): JSX.Element {
    const { getText } = useTranslation(props.stringProvider);

    function renderFooter(): JSX.Element {
        return (
            <div className={styles.footerContainer}>
                <Button
                    variant="neutral"
                    category="secondary"
                    onClick={props.onContinueWithoutEmail}
                    label={getText("ContinueWithoutEmailLabel")}
                    dataCy="login-cancelButton"
                />
                <Button
                    variant="brand"
                    category="primary"
                    label={getText("BackLabel")}
                    onClick={props.onBackButtonClick}
                    dataCy="login-BackButton"
                />

            </div>
        );
    }

    return (
        <Modal
            title={getText("RecoveryEmailIsMandatoryPopupTitle")}
            centerContent
            fixedOverlayPosition
            showOverlay
            disableOverlayClose
            footer={renderFooter()}
            dataCy="login-ContinueWithoutEmailPopup"
        >
            <div>
                <p>{getText("RecoveryEmailIsMandatoryMessage")}</p>
            </div>
        </Modal>
    );
}

export { RecoveryEmailIsMandatoryPopup };
